import { Constant } from 'src/constant';

export function isEmail(email: string): any {
    const regexpEmail = new RegExp(Constant.regexpEmail);
    return regexpEmail.test(email);
}

export function extractEmail(str: string): any {
    const reg = new RegExp(Constant.regexpExtractEmail);
    return str.match(reg)?.[0];
}
